import Main from '@/views/client/Main.vue'

// import Management from '@/views/manager/Management.vue'
// import Mailing from '@/components/manager/Mailing.vue'


const userRoute = {
  path: '/manager',
  redirect: '/manager/clients',
  component: Main,
  children: [
    // {
    //   key: 'clients',
    //   path: 'clients',
    //   component: Members,
    //   meta: {
    //     perimeter: managerPerimeter,
    //     perimeterAction: 'read'
    //   }
    // },
    // {
    //   key: 'management',
    //   path: 'management',
    //   component: Management,
    //   meta: {
    //     perimeter: managerPerimeter,
    //     perimeterAction: 'read'
    //   }
    // },
    // {
    //   key: 'mailing',
    //   path: 'mailing',
    //   component: Mailing,
    //   meta: {
    //     perimeter: managerPerimeter,
    //     perimeterAction: 'read'
    //   }
    // }
  ]
}

export default userRoute
